var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"background":"","layout":_vm.pageLayout,"current-page":_vm.currentPage,"page-size":_vm.pageSize,"small":_vm.isPaginationSmall,"total":_vm.total},on:{"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }